/**
 * Styled Components - Created by miguelcanobbio on 13/07/18.
 */
import * as React from 'react'
import styled from 'styled-components'
import {
  GREEN,
  GREEN_SELECTED,
  ORANGE,
  ORANGE_SELECTED,
  RED,
  WHITE,
  RED_TRANSPARENT,
  COLOR_IN_DESIGN,
  GRAY_DARK,
  GRAY_LIGHTEST
} from '../../../theme/colors'
import Icon from 'antd/lib/icon'
import Popover from 'antd/lib/popover'
import Select from 'antd/lib/select'
import Tooltip from 'antd/lib/tooltip'
import Checkbox from 'antd/lib/checkbox'

const MyPopover = ({ className, ...props }) => <Popover {...props} overlayClassName={className} />

export const Container = styled.tr`
  cursor: pointer;
  background-color: ${({ secondary }: CellProps) => secondary ? '#e617370f' : 'unset'}
  &:hover {
    background-color: #f6f6f6;
  }
`

interface CellProps {
  color?: string
  bold?: boolean
  codeColor?: string
  secondary?: boolean
  textAlign?: string
  blinking?: boolean
  link?: boolean
}

export const Cell = styled.td`
  border-bottom: 1px solid #d7d7d7;
  text-align: left;
  padding: 8px 0;
  position: relative;
  font-weight: ${({ bold }: CellProps) => bold ? 'bold' : 'normal'};
  color: ${({ color }: CellProps) => (color ? color : '#5f6062')};
  font-size: 12.5px;
  letter-spacing: 0.1px;
  line-height: 35px;
  text-transform: capitalize;
  width: ${({ secondary }: CellProps) => secondary ? '78px' : 'auto'};
  transition: all .25s;
  text-align: ${({ textAlign }: CellProps) =>
    textAlign ? textAlign : 'start'};
  &.error {
    color: ${RED};
  }
  @media (min-width: 331px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 12px;
  }

  @media (max-width: 330px) and (max-width: 768px) {
    letter-spacing: 0.09px;
    font-size: 11px;
  }
  ${({ blinking }: CellProps) => blinking ? `
    animation: blink 1s;
    animation-iteration-count: infinite;
    @keyframes blink { 50% { color: ${GREEN} ; }  }
  ` : ''}
  &:hover {
    animation: none;
    opacity: ${({ link }: CellProps) => link ? '0.5' : '1'};
    text-decoration: ${({ link }: CellProps) => link ? 'underline' : 'unset'};
  }
`

export const WarningIcon = styled(Icon)`
  font-size: 18px;
  color: ${RED};
  margin-right: 8px;
`

export const RevenueIcon = styled.img`
  max-width: 24px;
  width: 100%;
  margin-left: 16px;
  margin-bottom: 3px;
`

export const KanbanIcon = styled(Icon)`
  margin-left: 12px;
  font-size: 24px;
  path:first-child {
    fill: ${WHITE};
  }
`

export const StyledSelect = styled(Select)`
  width: 140px;
  margin-right: 8px;
`

export const CircleNotify = styled.div`
  width: 24px;
  font-size: 10px;
  color: white;
  font-weight: bold;
  height: 24px;
  background: ${RED_TRANSPARENT};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`

export const OnTime = styled.div`
  background: ${GREEN_SELECTED};
  width: 97px;
  text-align: center;
  border-radius: 2px;
  color: ${GREEN};
  font-weight: bold;
  font-size: 12px;
  display: flex;
  height: 28px;
  justify-content: center;
  align-items: center;
`

export const Urgent = styled.div`
  width: 97px;
  text-align: center;
  border-radius: 2px;
  color: ${RED};
  font-weight: bold;
  font-size: 12px;
  display: flex;
  height: 28px;
  justify-content: center;
  align-items: center;
`

export const Medium = styled.div`
  background: ${ORANGE_SELECTED};
  width: 97px;
  text-align: center;
  border-radius: 2px;
  color: ${ORANGE};
  font-weight: bold;
  font-size: 12px;
  display: flex;
  height: 28px;
  justify-content: center;
  align-items: center;
`

export const MemberList = styled.div`
  display: flex;
  align-items: center;
`

export const CircleMember = styled.div`
  color: ${WHITE};
  padding-top: 1px;
  padding-left: 1px;
  font-weight: bold;
  font-family: Avenir;
  border-radius: 25px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  margin-left: -7px
  background: ${({ codeColor }: CellProps) => codeColor || COLOR_IN_DESIGN};
`

export const StyledPopOver = styled(Tooltip)`
  cursor: pointer;
`

export const PopoverText = styled.div`
  font-size: 12px;
  color: ${GRAY_DARK};
`

export const PopOverValue = styled.div`
  margin: 7px 4px;
`

export const RevenueTitle = styled.div`
  font-family: Avenir;
  font-weight: bold;
  margin: 0px 4px;
`

export const CheckboxStyled = styled(Checkbox)`
  text-align: center;
  font-size: 12px;
  .ant-checkbox-inner {
    width: 13px;
    height: 13px;
    &:after {
      left: 2px;
      top: 0px;
      transform: rotate(45deg) scale(1) scale(0.8);
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #d76e7e;
    border-color: #d76e7e;
  }
`

export const DesignPopover = styled(MyPopover)`
  .ant-popover-inner-content {
    padding: 4px 6px;
  }
  .ant-popover-arrow {
    display: none;
  }
`

export const DesignThumbnail = styled.img`
  object-fit: cover;
  height: 150px;
  width: 170px;
  padding: 8px;
  background: ${GRAY_LIGHTEST};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const StatusLabel = styled.div`
  background: ${({ color }: CellProps) => color || WHITE};
  padding: 4px 8px;
  width: fit-content;
  line-height: normal;
  font-size: 11px;
  border-radius: 25px;
`

export const ImportedIcon = styled(Icon)`
  font-size: 10px;
  transform: rotate(-90deg);
  background: white;
  color: #7c61b4;
  border-radius: 25px;
  padding: 3px;
  border: 1px solid #dcd1f6;
  box-shadow: none;
  margin-left: 10px;
  vertical-align: unset;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TestPrintList/ItemOrder/styledComponents.tsx